import { request } from "../api_config/api_config";
import { API_URLS } from "../api_config/api_routes";

export const createDoctorConsultations_api = async ({ consultation }) => {
  try {
    console.log("consultations asdasad:", consultation);
    const res = await request.post(
      API_URLS.create_consultations_api_url,
      consultation,
    );
    if (res) {
      return res.data;
    }
  } catch (error) {
    // console.log("ERROR IN API CALL => ", error);
    console.log("error :", error);
    throw new Error(error.message);
  }
};
export const updateDoctorConsultations_api = async ({ consultations }) => {
  try {
    const res = await request.put(API_URLS.update_consultations_api_url, {
      consultations,
    });
    if (res) {
      return res.data;
    }
  } catch (error) {
    // console.log("ERROR IN API CALL => ", error);
    throw new Error(error.message);
  }
};
export const singleUpdateDoctorConsultations_api = async ({ consultation }) => {
  try {
    const res = await request.put(API_URLS.singleupdate_consultations_api_url, {
      ...consultation,
    });
    if (res) {
      return res.data;
    }
  } catch (error) {
    // console.log("ERROR IN API CALL => ", error);
    throw new Error(error.message);
  }
};
export const deleteDoctorConsultations_api = async ({ consultationId }) => {
  try {
    console.log("consultationId :", consultationId);
    const res = await request.delete(
      `${API_URLS.delete_consultations_api_url}/${consultationId}`,
    );
    if (res) {
      return res.data;
    }
  } catch (error) {
    // console.log("ERROR IN API CALL => ", error);
    throw new Error(error.message);
  }
};
export const getDoctorConsultations_api = async ({ doctorId = null } = {}) => {
  try {
    const url = `${API_URLS.get_consultations_api_url}${doctorId ? `/${doctorId}` : ""}`;
    const res = await request.get(url);
    if (res) {
      return res.data;
    }
  } catch (error) {
    // console.log("ERROR IN API CALL => ", error);
    throw new Error(error.message);
  }
};
